import { render, staticRenderFns } from "./IconHeartFilled.vue?vue&type=template&id=d47d9506&"
import script from "./IconHeartFilled.vue?vue&type=script&lang=js&"
export * from "./IconHeartFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports